module.exports = __webpack_public_path__ + "img/find_kelly.2be4314a.jpg";